module.exports = __webpack_public_path__ + "static/J2021_IEEERobo_abs-03d228dac37faddbe0d01869057cc097.gif";